import utc from 'dayjs/plugin/utc';
import { DAYJS_FORMAT } from '@/config/common';
dayjs.extend(utc);
export function formatUtcString(utcString) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DAYJS_FORMAT.YYYYMMDD_HHMMSS;
  return dayjs.utc(utcString).utcOffset(8).format(format);
}